<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.layer.name')}`"
    width="50%"
  >
    <base-form ref="form" v-model="valid" @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.workspace_id"
            autofocus
            :items="form.workspaces.items"
            item-text="name"
            item-value="id"
            :error-messages="dialog.error.workspace_id"
            filled
            label="Không gian làm việc"
            no-label
            type-input="v-select"
            :rules="form.workspaces.rules"
            :loading="form.workspaces.loading"
            :disabled="form.workspaces.loading"
          ></field-group>
          <field-group
            v-model="dialog.data.datastore_id"
            :items="form.datastores.items"
            item-text="name"
            item-value="id"
            :error-messages="dialog.error.workspace_id"
            filled
            :label="
              dialog.data.workspace_id
                ? $t('sidebar.datastore.name')
                : $t('sidebar.datastore.name') +
                  ' (Yêu cầu ' +
                  $t('sidebar.workspace.name') +
                  ')'
            "
            no-label
            lazy-validation
            type-input="v-select"
            :rules="form.datastores.rules"
            :loading="form.datastores.loading"
            :disabled="form.datastores.loading || !dialog.data.workspace_id"
          ></field-group>
          <field-group
            v-model="dialog.data.datastore_detail_id"
            :items="form.datastore_details.items"
            item-text="name"
            item-value="id"
            :error-messages="dialog.error.datastore_detail_id"
            filled
            :label="
              dialog.data.datastore_id
                ? 'Tài nguyên'
                : 'Tài nguyên' +
                  ' (Yêu cầu ' +
                  $t('sidebar.datastore.name') +
                  ')'
            "
            no-label
            type-input="v-select"
            lazy-validation
            :rules="form.datastore_details.rules"
            :loading="form.datastore_details.loading"
            :disabled="
              form.datastore_details.loading || !dialog.data.datastore_id
            "
          ></field-group>
          <field-group
            v-model="dialog.data.name"
            :error-messages="dialog.error.name"
            filled
            label="Tên hiển thị"
            no-label
            type-input="v-text-field"
            :rules="form.name.rules"
            :loading="form.name.loading"
            :disabled="form.name.loading"
          ></field-group>
        </v-col>
      </v-row>
    </base-form>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
        :disabled="!valid"
      >
        Thêm mới
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_LAYER, API_LAYERGROUP, API_WORKSPACE, API_DATASTORE } from '@api'
import { mapGetters } from 'vuex'
import workspaces from '@/src/router/routes/workspaces'
export default {
  components: {},
  props: {
    workspace: { type: Array, default: () => [] },
  },
  data: () => ({
    valid: false,
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    form: {
      workspaces: {
        items: [],
        loading: false,
        rules: [(value) => !!value || 'Không được để trống.'],
      },

      datastores: {
        items: [],
        loading: false,
        params: {
          sort: 'name',
          with: 'details',
          enabled: true,
          workspace_id: '',
        },
        rules: [(value) => !!value || 'Không được để trống.'],
      },
      datastore_details: {
        items: [],
        loading: false,
        rules: [(value) => !!value || 'Không được để trống.'],
      },
      name: {
        loading: false,
        rules: [(value) => !!value || 'Không được để trống.'],
      },
    },
  }),
  watch: {
    'dialog.data.workspace_id'(newValue) {
      this.dialog.data = { workspace_id: newValue }
      if (!newValue) {
        this.form.datastores.items = []
        return
      }
      this.form.datastores.loading = true
      this.form.datastores.params.workspace_id = newValue
      API_DATASTORE.list(this.form.datastores.params)
        .then((res) => {
          this.form.datastores.items = res.data
        })
        .finally(() => {
          this.form.datastores.loading = false
        })
    },
    'dialog.data.datastore_id'(newValue) {
      if (!newValue) {
        this.form.datastore_details.items = []
        return
      }
      let currentDatastore = this.form.datastores.items.find((x) => {
        return x.id == newValue
      })
      if (!currentDatastore) {
        return
      }
      this.form.datastore_details.items = currentDatastore.details
    },
    'dialog.data.datastore_detail_id'(newValue) {
      if (!newValue) {
        return
      }
      let currentDatastoreDetail = this.form.datastore_details.items.find(
        (x) => {
          return x.id == newValue
        }
      )
      if (!currentDatastoreDetail) {
        return
      }
      this.dialog.data.name = currentDatastoreDetail.name
    },
  },

  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({}, item))

      this.form.workspaces.loading = true
      this.form.workspaces.items = this.workspace
      this.form.workspaces.loading = false
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        this.dialog.loading = true
        let res = await API_DATASTORE.publish(
          this.dialog.data.datastore_id,
          this.dialog.data.datastore_detail_id,
          {
            name: this.dialog.data.name,
          }
        )

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
